import { createReducer, on } from '@ngrx/store';
import { loadFeatureFlagsAndLimits, loadFeatureFlagsAndLimitsFailure, loadFeatureFlagsAndLimitsSuccess } from './actions';
import { initialFeatureFlagsAndLimitsInitialState } from './state';

export const FEATURE_FLAGS_AND_LIMITS_FEATURE_KEY = 'featureFlagsAndLimits';

export const featureFlagsAndLimitsReducer = createReducer(
  initialFeatureFlagsAndLimitsInitialState,
  on(loadFeatureFlagsAndLimits, (state) => {
    return {
      ...state,
      loading: true
    }
  }),
  on(loadFeatureFlagsAndLimitsSuccess, (state, { features, limits, downtime }) => ({
    ...state,
    features,
    limits,
    downtime
  })),
  on(loadFeatureFlagsAndLimitsFailure, (state, action) => {
    return {
      ...state,
      error: action.error,
    };
  })
);
